import {ElementRef, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {WidgetInstance} from 'friendly-challenge';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  private readonly puzzleEndpoint = 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle';

  constructor() { }
  
  
  public initCaptcha(relatedFormGroup: FormGroup, captchaElemRef: ElementRef, htmlCtrlName: string): void {
    console.log();
    const captchaOptions = {
      sitekey: environment.siteKey,
      puzzleEndpoint: this.puzzleEndpoint,
      startMode: 'auto',
      doneCallback: (a: string) => {
        relatedFormGroup.get(htmlCtrlName)?.patchValue(a);
      },
      errorCallback: () => {
      },
      // These options are only added temporarily until friendly captcha fixes their ts interface
      language: navigator.language.substring(0, 2),
      readyCallback: () => {
      },
      startedCallback: () => {
      },
      forceJSFallback: false,
      skipStyleInjection: true
    };
    // @ts-ignore
    new WidgetInstance(captchaElemRef?.nativeElement, captchaOptions);
  }
}
